import { render, staticRenderFns } from "./StudentImport.vue?vue&type=template&id=78b8dc95&"
import script from "./StudentImport.vue?vue&type=script&lang=js&"
export * from "./StudentImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports